export default class extends Controller {
  connect() {
    App.Dashboard.init();
  }
}



// WEBPACK FOOTER //
// ./app/components/dashboards/assets/javascript/dashboards-multi-dashboard-controller.js